(function (scope) {
  'use strict';
  function selection(config, values) {
    const chosen = [], errors = [], properties = {}, ids = {};
    const labels = new Set();
    for (const set of config.sets || []) {
      if (!set.id || !set.label || labels.has(set.label) || set.label.startsWith('_') || set.label === 'Fabric') { errors.push('Invalid or repeated option label.'); continue; }
      labels.add(set.label);
      const value = values[set.id];
      if (set.input === 'text') {
        const text = String(value || '').trim();
        if (set.required && !text) errors.push(set.label + ' is required.');
        if (text.length > 300) errors.push(set.label + ' must be 300 characters or fewer.');
        if (text) { properties[set.label] = text; ids[set.id] = text; }
        continue;
      }
      if (set.input === 'quantity') {
        const count = Number(value ?? 0), choice = (set.choices || [])[0];
        if (!Number.isInteger(count) || count < 0 || count > (set.max ?? 10)) { errors.push(set.label + ' quantity is invalid.'); continue; }
        ids[set.id] = count;
        if (count === 0) continue;
        if (!choice || !choice.variant || !Number.isInteger(choice.price) || choice.price <= 0) { errors.push('The upgrade for ' + set.label + ' is not ready.'); continue; }
        chosen.push({set, choice, quantity:count}); properties[set.label] = String(count) + ' × ' + choice.label;
        continue;
      }
      const choice = (set.choices || []).find(item => item.id === value);
      if (!choice) { if (set.required || value) errors.push('Choose ' + set.label.toLowerCase() + '.'); continue; }
      if (choice.paid && (!choice.variant || !Number.isInteger(choice.price) || choice.price <= 0)) errors.push('The upgrade for ' + choice.label + ' is not ready.');
      chosen.push({ set, choice }); properties[set.label] = choice.label; ids[set.id] = choice.id;
    }
    return { chosen, properties, ids, errors, surcharge: chosen.reduce((sum, item) => sum + (item.choice.paid && Number.isInteger(item.choice.price) ? item.choice.price * (item.quantity || 1) : 0), 0) };
  }
  function build(config, row, values, quantity, group, allowUnavailable) {
    const selected = selection(config, values);
    const errors = [...selected.errors];
    if (!row || !/^\d+$/.test(String(row.id)) || !Number.isInteger(row.price) || row.price <= 0) errors.push('Choose an available fabric.');
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 20) errors.push('Quantity must be between 1 and 20.');
    if (!group || typeof group !== 'string') errors.push('Missing configuration reference.');
    if (!allowUnavailable && row && !row.available) errors.push('This fabric is currently unavailable.');
    if (!allowUnavailable && selected.chosen.some(({choice}) => choice.paid && !choice.available)) errors.push('A selected upgrade is currently unavailable.');
    if (errors.length) return { errors, items: [], total: null };
    const paid = selected.chosen.filter(({choice}) => choice.paid);
    const properties = { ...selected.properties, Fabric: row.name || row.title, _couchery_config: group, _couchery_selections: JSON.stringify(selected.ids), _couchery_product: String(config.productId), _couchery_expected: JSON.stringify(paid.map(({choice}) => String(choice.variant))) };
    const items = [{ id: String(row.id), quantity, properties }];
    const seen = new Set();
    for (const {set, choice, quantity: units = 1} of paid) {
      if (seen.has(String(choice.variant))) return { errors: ['Each paid option must use a distinct upgrade variant.'], items: [], total: null };
      seen.add(String(choice.variant));
      items.push({ id: String(choice.variant), quantity: quantity * units, parent_id: String(row.id), properties: { _couchery_config: group, _couchery_parent: String(row.id), _couchery_option: set.id, _couchery_choice: choice.id, _couchery_units: String(units), Configuration: row.name || row.title, Option: set.label + ': ' + choice.label } });
    }
    return { errors: [], items, total: (row.price + selected.surcharge) * quantity, unit: row.price + selected.surcharge };
  }
  function inspectCart(cart, configurations, addonProducts = []) {
    const errors = [], items = cart.items || [];
    const parents = items.filter(item => item.properties && item.properties._couchery_selections && item.properties._couchery_config);
    for (const item of items) {
      if (configurations[String(item.product_id)] && !item.properties?._couchery_parent && !parents.includes(item)) errors.push('Please choose the options for ' + item.product_title + '.');
      if (addonProducts.includes(String(item.product_id)) && (!item.properties?._couchery_parent || !item.parent_relationship?.parent_key)) errors.push('An upgrade must be attached to a configured sofa.');
    }
    for (const parent of parents) {
      const config = configurations[String(parent.product_id)];
      if (!config) { errors.push('Configuration settings are missing for ' + parent.product_title + '.'); continue; }
      let values;
      try { values = JSON.parse(parent.properties._couchery_selections); } catch (_) { errors.push('Configuration data is invalid.'); continue; }
      const selected = selection(config, values);
      errors.push(...selected.errors);
      const group = parent.properties._couchery_config;
      const children = items.filter(item => item.properties && item.properties._couchery_config === group && item.properties._couchery_parent);
      const expected = selected.chosen.filter(({choice}) => choice.paid);
      if (children.length !== expected.length) errors.push('A configuration upgrade is missing or repeated.');
      for (const {set, choice, quantity: units = 1} of expected) {
        const match = children.filter(item => String(item.variant_id) === String(choice.variant) && item.properties._couchery_option === set.id && item.properties._couchery_choice === choice.id);
        if (match.length !== 1 || match[0].quantity !== parent.quantity * units) errors.push('Upgrade quantities do not match the sofa.');
        if (match.length === 1 && match[0].parent_relationship?.parent_key !== parent.key) errors.push('An upgrade is not attached to its sofa.');
        if (match.length === 1 && match[0].original_price !== choice.price) errors.push('An upgrade price changed. Please configure the sofa again.');
      }
    }
    for (const child of items.filter(item => item.properties?._couchery_parent)) {
      if (!parents.some(parent => parent.properties._couchery_config === child.properties._couchery_config && String(parent.variant_id) === child.properties._couchery_parent)) errors.push('An upgrade has no matching sofa.');
    }
    return [...new Set(errors)];
  }
  scope.CoucheryOptions = Object.freeze({ selection, build, inspectCart });
})(typeof window !== 'undefined' ? window : globalThis);

